import { ofType } from "redux-observable";
import { switchMap } from "rxjs/operators";
import { from, of } from "rxjs";
import { RequestErrorBadRequest } from "@errors/RequestError";
import deepMerge from "@helper/deepMerge";

export const USER_LOADED = "pss/user/LOADED";
export const USER_UPDATE_SETTINGS = "pss/user/UPDATE_SETTINGS";
export const USER_CLEAR_SETTINGS = "pss/user/CLEAR_SETTINGS";
export const USER_UPDATE_SETTINGS_SUCCESS = "pss/user/UPDATE_SETTINGS_SUCCESS";
export const USER_UPDATE_SETTINGS_ERROR = "pss/user/UPDATE_SETTINGS_SUCCESS";

const initialState = {
  model: {},
  settings: {},
  updating: false,
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case USER_LOADED:
      return {
        ...initialState,
        ...action.payload,
      };
    case USER_UPDATE_SETTINGS:
      return {
        ...state,
        settings: deepMerge([state.settings, action.payload]),
        updating: true,
        error: null,
      };
    case USER_UPDATE_SETTINGS_SUCCESS:
      return { ...state, settings: action.payload, updating: false };
    case USER_UPDATE_SETTINGS_ERROR:
      return { ...state, error: action.payload, updating: false };
    default:
      return state;
  }
}

export function userLoaded(model, settings) {
  return {
    type: USER_LOADED,
    payload: {
      model,
      settings,
    },
  };
}

export function userUpdateSettings(settings) {
  return { type: USER_UPDATE_SETTINGS, payload: settings };
}

function userUpdateSettingsSuccess(settings) {
  return { type: USER_UPDATE_SETTINGS_SUCCESS, payload: settings };
}

function userUpdateSettingsError(error) {
  return { type: USER_UPDATE_SETTINGS_ERROR, payload: error };
}

function buildSettingsParams(settings) {
  const { version, writeDate, ...params } = settings;
  return { settings: params };
}

export function updateSettingsEpic(action$, store$, { api }) {
  return action$.pipe(
    ofType(USER_UPDATE_SETTINGS),
    switchMap(() => {
      const { settings } = store$.value.user;
      return from(
        api.safeFetchPut("/Session/Settings", buildSettingsParams(settings))
      ).pipe(
        switchMap((response) => {
          if (response.error)
            return of(
              userUpdateSettingsError(
                RequestErrorBadRequest({}, response.error)
              )
            );
          return of(
            userUpdateSettingsSuccess({ ...settings, ...response.data })
          );
        })
      );
    })
  );
}

export function clearSettingsEpic(action$, _, { api }) {
  return action$.pipe(
    ofType(USER_CLEAR_SETTINGS),
    switchMap(() => {
      return from(
        api.safeFetchPut("/Session/Settings", buildSettingsParams({}))
      ).pipe(
        switchMap((response) => {
          if (response.error)
            return of(
              userUpdateSettingsError(
                RequestErrorBadRequest({}, response.error)
              )
            );
          return of(userUpdateSettingsSuccess(response.data));
        })
      );
    })
  );
}

export const userEpics = [updateSettingsEpic, clearSettingsEpic];
